// ---------------------------------------------------------------------------
// Avliana-Bildmarke: der Bogen. Verbindliches Regelwerk: memory/BRAND_AVLIANA.md
//
// Bewusst INLINE-SVG statt Import aus assets/brand/*.svg: Dieses Projekt hat
// noch nie ein SVG importiert, der CRA/CRACO-SVGR-Pfad ist hier also ungetestet.
// Inline kostet nichts (die Pfade sind winzig) und kann nicht am Build scheitern.
// Die Dateien unter assets/brand/ bleiben die Quelle fuer Design/Export.
//
// Geometrie: viewBox eng auf die Marke beschnitten (14 22 72 68), damit sie in
// Flex-Zeilen ohne Eigenluft sitzt. Bogen nie verzerren, nie neigen, nie mit
// Verlauf fuellen.
// ---------------------------------------------------------------------------

/**
 * @param {string}  className  Groesse/Farbe von aussen (z. B. "h-7 w-auto").
 * @param {boolean} mono       Einfarbig: erbt die Textfarbe via currentColor und
 *                             laesst den Durchgang weg. Fuer dunkle Flaechen
 *                             (Footer) und einfarbigen Druck.
 */
export default function AvlianaLogo({ className = "", mono = false }) {
  return (
    <svg
      viewBox="14 22 72 68"
      className={className}
      role="img"
      aria-label="Avliana"
      focusable="false"
    >
      <path
        d="M 14 90 L 14 58 A 36 36 0 0 1 86 58 L 86 90 Z M 30 90 L 30 58 A 20 20 0 0 1 70 58 L 70 90 Z"
        fill={mono ? "currentColor" : "#BC4A2B"}
        fillRule="evenodd"
      />
      {/* Der Durchgang: der Hof, in den man tritt. Entfaellt einfarbig. */}
      {!mono && <path d="M 42 90 L 42 70 A 8 8 0 0 1 58 70 L 58 90 Z" fill="#2C7A7B" />}
    </svg>
  );
}
